// Components==============
import EvidenceCard from 'components/UI/EvidenceCard/EvidenceCard';
import React, { useContext, useRef } from 'react';
import { MyPortfolioContext } from '../../MyPortfolio';
import './DraggableEvidenceCard.module.scss';
import PortfolioText from '../PortfolioText/PortfolioText';
// =========================

export default function DraggableEvidenceCard({
  evidence,
}: {
  evidence: EvidenceEvidenceEntity;
}) {
  const {
    handleDeletePortfolioItem,
    evidenceEntities,
    handleReorder,
    currentPortfolio,
  } = useContext(MyPortfolioContext);

  const imageRef = useRef<HTMLDivElement>(null);

  function handleDragStart(e: React.DragEvent<HTMLDivElement>) {
    e.dataTransfer.setData('text/plain', `${evidence.id}`);

    e.dataTransfer.dropEffect = 'move';

    return (
      imageRef.current &&
      e.dataTransfer.setDragImage(
        imageRef.current,
        imageRef.current.clientWidth / 2,
        imageRef.current.clientHeight / 2
      )
    );
  }

  function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }

  function handleDrop(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    const dragId = parseInt(e.dataTransfer.getData('text/plain'));
    const dropId = evidence.id;

    if (dragId === dropId) return;

    const items = evidenceEntities?.map((ev, i) => ({
      id: ev?.id,
      order: i,
    })) as { id: number; order: number }[];

    const newItems = items?.map((item, order) => {
      if (item.id === dragId) return { id: dropId, order };
      if (item.id === dropId) return { id: dragId, order };

      return item;
    });

    handleReorder(newItems);
  }

  return (
    <div
      draggable="true"
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      styleName="wrapper"
    >
      {evidence.type === 'portfolio' ? (
        <PortfolioText
          handleDelete={handleDeletePortfolioItem}
          evidence={evidence}
        />
      ) : (
        <EvidenceCard
          portfolio
          height="100%"
          evidence={evidence}
          handleDelete={handleDeletePortfolioItem}
          disableComments={currentPortfolio?.visibility === 'private'}
          imageRef={imageRef}
        />
      )}
    </div>
  );
}
